import { RouteItem } from '@eastcoal/router/types/route'

import { TRADE_ORDER_PAGE_UUID } from './constants/uuid'

export const tradeOrderRoute: RouteItem = {
  title: '交易订单',
  uuid: TRADE_ORDER_PAGE_UUID,
  path: '/tradeOrder',
  Component: () => import('./index')
}
